import React, { useContext, Fragment } from "react";
import clsx from "clsx";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Tooltip, Button } from "@material-ui/core";
import {
  PoleDefault,
  CableDefault,
  TriangleDefault,
  RelayDefault,
  RelayLabel,
  SwitchDefault,
  MeterDefault,
  RiserTransformerDefault,
} from "../material/icons/equipemnt";
import { DesignContext } from "../context/design";
import { equipList } from "../constant/equip-options";
import { LangContext } from "../context/lang";

const useStyle = makeStyles((theme: Theme) => ({
  gridEquip: { display: "flex", justifyContent: "center" },
  equip: {
    width: theme.spacing(12),
    height: theme.spacing(12),
    padding: theme.spacing(2),
  },
  paper: {
    display: "flex",
    justifyContent: "center",
    padding: 0,
    borderRadius: theme.spacing(1),
  },
  whiteBtn: { backgroundColor: theme.palette.common.white },
  flexMiddle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
}));

const EquipDesign = () => {
  const classes = useStyle();
  const { event, setevent } = useContext(DesignContext);
  const { lang } = useContext(LangContext);
  const langData: any = lang.data;

  return (
    <Grid container spacing={2}>
      {equipList.map((equip) => {
        const strokeColor = event?.type === equip.type ? "#ffffff" : "#595A5A";

        return (
          <Grid key={equip.id} item xs={6} className={classes.gridEquip}>
            <Tooltip title={langData[equip.id]} placement="top">
              <Button
                variant="contained"
                className={clsx(
                  event?.type !== equip.type && classes.whiteBtn,
                  classes.paper
                )}
                onClick={() => {
                  setevent(
                    event?.type === equip.type
                      ? { ...event, type: undefined }
                      : { ...event, type: equip.type }
                  );
                }}
                color={event?.type === equip.type ? "primary" : "default"}
              >
                {equip.type === "equip-pole" ? (
                  <PoleDefault
                    viewBox="9 9 32 32"
                    className={classes.equip}
                    style={{
                      fill: "none",
                      fillOpacity: 0.5,
                      strokeWidth: 1,
                      stroke: strokeColor,
                    }}
                  />
                ) : equip.type === "equip-cable" ? (
                  <CableDefault
                    className={classes.equip}
                    style={{
                      strokeWidth: 1.5,
                      stroke: strokeColor,
                    }}
                  />
                ) : equip.type === "equip-relay" ? (
                  <Fragment>
                    <RelayDefault
                      className={classes.equip}
                      style={{
                        strokeWidth: 2,
                        stroke: strokeColor,
                        fill: "none",
                      }}
                    >
                      <RelayLabel
                        className={classes.equip}
                        style={{
                          fill: strokeColor,
                        }}
                      >
                        RL
                      </RelayLabel>
                    </RelayDefault>
                  </Fragment>
                ) : equip.type === "equip-transformer" ? (
                  <TriangleDefault
                    className={classes.equip}
                    style={{
                      strokeWidth: 2,
                      stroke: strokeColor,
                      fill: "none",
                    }}
                  />
                ) : equip.type === "equip-switch" ? (
                  <SwitchDefault
                    className={classes.equip}
                    style={{
                      strokeWidth: 2,
                      stroke: strokeColor,
                      fill: "none",
                    }}
                  />
                ) : equip.type === "equip-meter" ? (
                  <MeterDefault
                    className={classes.equip}
                    style={{
                      strokeWidth: 2,
                      stroke: strokeColor,
                      fill: "none",
                    }}
                  />
                ) : (
                  <RiserTransformerDefault
                    className={classes.equip}
                    style={{
                      strokeWidth: 2,
                      stroke: strokeColor,
                      fill: "none",
                    }}
                  />
                )}
              </Button>
            </Tooltip>
          </Grid>
        );
      })}
      <Grid item xs={12}>
        <Typography variant="subtitle1" color="primary" align="center">
          {lang.data.chooseEquip}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default EquipDesign;
